import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation,  Input  } from '@angular/core';
import { FormBuilder,FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

import { MatSnackBar } from "@angular/material/snack-bar";

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

//SERVICE
import { DemographicService } from "../../services/demographics.service";
import {TranslateService} from '@ngx-translate/core';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
@Component({
    selector     : 'demographic',
    templateUrl  : './demographic.component.html',
    styleUrls    : ['./demographic.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DemographicComponent {
  @Input('pasoCompleto') pasoCompleto?: boolean;
  catalogo: any;
  selectedValue = 0;

  centered = false;
  disabled = false;
  unbounded = false;
  banderaSelect: boolean = false;
  preguntas: any;

  radius: number;
  color: string;

  user: FormGroup;
  password: FormGroup;
  RESPONSE: FormGroup;
  RESPONSE2: FormGroup;
  RESPONSE3: FormGroup;
  LEVEL: FormGroup;
  styleElement: HTMLStyleElement;
  ordenDemograficos:any;

  constructor(private _formBuilder: FormBuilder,
              private serviceTranslate: TranslateService,
              private demographicService: DemographicService,
              private wizardService: WizardService,
              public snackBar: MatSnackBar,
              private _fuseTranslationLoaderService: FuseTranslationLoaderService) {

      lang_certificar.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });

  }

  ngOnInit() {
    this.user = this._formBuilder.group({
      //firstCtrl: ['', Validators.required]
    });
    this.password = this._formBuilder.group({
      //secondCtrl: ['', Validators.required]
    });
    this.RESPONSE = this._formBuilder.group({
      //thirdCtrl: ['', Validators.required]
    });
    this.RESPONSE2 = this._formBuilder.group({
      //fourthCtrl: ['', Validators.required]
    });
    this.RESPONSE3 = this._formBuilder.group({
      //fourthCtrl: ['', Validators.required]
    });
    this.LEVEL = this._formBuilder.group({
      //fourthCtrl: ['', Validators.required]
    });

    this.check();
    this.getBanderaDemograficos();

    this.getCatalogo();
    this.obtieneInstituto();
    this.styleElement = document.createElement('style');
    //this.cambiaColorProgress();


  }
  instituto:any;
  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
case '2': case 'CAyC': this.instituto = 'CAyC'; break;
case '3': case 'HK': this.instituto = 'HK'; break;
case '4': case 'SGP': this.instituto = 'SGP'; break;
case '5': case 'TK': this.instituto = 'TK'; break;
case '6': case 'FL': this.instituto = 'FL'; break;
case '11': case 'BR': this.instituto = 'BR'; break;
    }
    console.log("Instituo "+this.instituto);
  }

arregloOrdenado:any[]=[];
showCtalogo:boolean=false;
catalogo_tmp:any[]=[];
  public getCatalogo(lastDemo?){
    // Este valor por parametro opcional es ya que cuando eliminas el último demográfico no actualiza el 
    // cátalogo correctamente. Por lo cual se ocupa un if en la parte de abajo.
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    console.log(data);
    this.demographicService.catalogoDemograficos(data)
    .subscribe(response => {
      console.log(response );
      if(response['message'] == 'Success'){
        this.catalogo = response['catalogoDemograficos'];
        console.log("Ctalogo");
        console.log(this.catalogo);
        //console.log(this.preguntas);
        if(this.catalogo.length == 0){
          console.log("Porque");
          this.showCtalogo=false;
        }else{
          this.showCtalogo=true;
          this.arregloOrdenado=this.catalogo;
          this.arregloOrdenado.sort((a,b) => a.clave.localeCompare(b.clave));
          this.catalogo=this.arregloOrdenado;
          this.catalogo_tmp=[];
          if(this.preguntas){
            console.log("Entro");
            if(this.preguntas.length > 0){
              if(lastDemo){
                for(let i=0; i < this.catalogo.length; i++){
                  
                  this.catalogo_tmp.push(this.catalogo[i]);
                  
                }
              }else{
                for(let i=0; i < this.catalogo.length; i++){
                  let templateInstituto = this.preguntas.find(buscado => buscado.clave == this.catalogo[i].clave);
                  if(templateInstituto != undefined){
                    console.log("Los que estan "+this.catalogo[i].clave);
                  }else{
                    this.catalogo_tmp.push(this.catalogo[i]);
                  }
                }
              }
              
              console.log("Nuevo catalogo");
              console.log(this.catalogo_tmp);
            }
          }else{
            console.log("Aun no tienes nada mamon");
            this.catalogo_tmp=this.catalogo;
          }
          
        }
      }
    }, error => {
      console.log("error", error);
    });
  }

  actualizarCheck:boolean=false;
  mensajeActualizar:string;
  togglePanel(index) {
    console.log("Entro panel "+index);
    if(this.actualizarCheck){
      this.actualizarCheck=false;
      console.log("Actualizar check");
      //this.openSuccessSnackBar(this.mensajeActualizar,'OK');
      this.check(1);
    }
 
  }

  public check(bandera?){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    };

    this.demographicService.getQuestions(data)
    .subscribe(response => {

      console.log(response);

      if(response['message'] == 'Success'){
        if(response['demograficos'].length > 0){
            this.catalogo_tmp=[];
            this.preguntas = response['demograficos'];
            console.log(this.preguntas);
            console.log(this.preguntas[this.preguntas.length-1].orden);
            console.log(this.preguntas[0].orden);
            if(bandera == 1){
              if(this.preguntas){
                if(this.preguntas.length > 0){
                  for(let i=0; i < this.catalogo.length; i++){
                    let templateInstituto = this.preguntas.find(buscado => buscado.clave == this.catalogo[i].clave);
                    if(templateInstituto != undefined){
                      console.log("Los que estan "+this.catalogo[i].clave);
                    }else{
                      this.catalogo_tmp.push(this.catalogo[i]);
                    }
                  }
                  console.log("Nuevo catalogo");
                  console.log(this.catalogo_tmp);
                }else{
                  console.log("Estan vacios todos rayos");
                  this.preguntas=null;
                }
              }
            }
           
    
        }else{
          if(bandera == 1){
            this.getCatalogo(1);
          }
          console.log('FALSEEEEEE');
          this.guardarDemograficos();
        }
      }

    }, error => {
      console.log("error", error);
    });
  }

    public onBlurPregunta(event,pregunta){
      if(event.target.value.length > 0){
        let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            demograficoId: pregunta._id,
            preguntaDemografico: event.target.value
        };
        //this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.MSJ_TRANSLATEREGISTERED'),this.serviceTranslate.instant('ALERTS.OK'));
        this.updateData(data,this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDOK'));
      }else{
        this.openErrorSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDFAIL'),this.serviceTranslate.instant('ALERTS.OK'));
      }
    }

    public changueSelect(pregunta,bandera){
        let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            demograficoId: pregunta._id,
            bandera: bandera
        };
        //console.log(data);
        //this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.MSJ_TRANSLATEREGISTERED'),this.serviceTranslate.instant('ALERTS.OK'));
        this.updateData(data,this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDOK'));
    }

    public onBlurRespuesta(event,opcion,id){

      if(event.target.value.length > 0){
        if(opcion._id == 'NEW'){
          let data = {
              fechaCertificar: localStorage.getItem('fechaProducto'),
              demograficoId: id,
              orden: opcion.ordenOpcion,
              textoOpcion: event.target.value
          };
          this.sendNewResponse(data,id,this.serviceTranslate.instant('CERTIFICAR.FORALL.RESPONSEUPDATEDOK'));
        }else{
            let data = {
                fechaCertificar: localStorage.getItem('fechaProducto'),
                demograficoId: id,
                opcionId: opcion._id,
                textoOpcion: event.target.value
            };
          this.updateData(data,this.serviceTranslate.instant('CERTIFICAR.FORALL.RESPONSEUPDATEDOK'));
        }
      }else{
        this.openErrorSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.RESPONSEUPDATEDFAIL'),this.serviceTranslate.instant('ALERTS.OK'));
      }
    }

    public sendNewResponse(data,id,mensaje){
      //console.log(data.ordenOpcion);
      this.demographicService.addResponse(data)
        .subscribe(response => {

          if(response['message'] == 'Success'){
            let opcion = {
                _id: response['opcionDemografico']['_id'],
                ordenOpcion: data.orden,
                textoOpcion: data.textoOpcion
            }

            let respuesta = this.preguntas.find(x=>x._id == id).opciones;

            let newArray = respuesta.find(y=>y._id == 'NEW')._id = response['opcionDemografico']['_id'];

            this.preguntas.find(x=>x._id == id).opciones = respuesta;
            this.openSuccessSnackBar(mensaje,'OK');
          }
        }, error => {
          console.log("error", error);
        });
    }

    drop(event: CdkDragDrop<string[]>,id?:any) {
      let respuesta = this.preguntas.find(x=>x._id == id).opciones;
      moveItemInArray(respuesta, event.previousIndex, event.currentIndex);

      this.updateOrden(respuesta,id);
    }

    onDrop(event: CdkDragDrop<string[]>) {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex);
      }
    }

    public updateOrden(arreglo:any[],id?:any){
      let count = 0;
      for (let i = 0; i < arreglo.length; i++){
        let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            demograficoId: id,
            opcionId: arreglo[i]['_id'],
            ordenOpcion: i+1
        };
        if(data.opcionId==arreglo[i]['_id'] && data.ordenOpcion!=arreglo[i]['ordenOpcion']){
          this.ordenDemograficos=data;
          count=arreglo[i]['ordenOpcion']-data.ordenOpcion;
          if(arreglo[i]['ordenOpcion']>=3 && count>1){
            this.ordenDemograficos=data;
            break;
          }

        }
        else{
          console.log('No hizo cambios');
        }
        // count = count+1;
        console.log(data);

      }
      console.log(this.ordenDemograficos);
      this.ordenRequest(this.ordenDemograficos);
    }

    public ordenRequest(data){
      this.modalCargaOpcion();
      this.demographicService.updateDemographicData(data)
        .subscribe(response => {
        console.log(response);
          if(response['message'] == 'Success'){
            this.check();
            this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.RESPONSEUPDATEDOK'),'OK');
            Swal.close();
          }
        }, error => {
          console.log("error", error);
        });
    }

    modalCargaOpcion(){
      let mensaje: string;
      this.serviceTranslate.get('CERTIFICAR.FORALL.ACTUALIZAR_OPCION').subscribe((res: string) => { mensaje = res; });

      Swal.fire({
        title: mensaje,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        }
      });
    }

    public updateData(data,mensaje){

      this.demographicService.updateDemographicData(data)
        .subscribe(response => {
          //console.log(response);
          if(response['message'] == 'Success'){
            //INSERTO CORRECTAMENTE LAS OPCIONES DE RESPUESTA
            this.mensajeActualizar = mensaje;
            this.actualizarCheck=true;
            this.openSuccessSnackBar(mensaje,'OK');
            //this.check();
          }
        }, error => {
          console.log("error", error);
        });
    }

    openErrorSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
           duration: 15000,
           verticalPosition: 'top',
           panelClass: ['background-red']
        });
     }


     openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
           duration: 15000,
           verticalPosition: 'top',
           panelClass: ['background-success'],
           
        });
     }


  public guardarDemograficos(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto'),
      productoId: localStorage.getItem('productoID')
    }
    //console.log(data);
    this.demographicService.guardarDemograficos(data)
      .subscribe(response => {
        console.log('ANTES....');
        console.log(response);
        console.log('DESPUES....');
        if(response['message'] == 'Success'){
          if(response['demograficos'].length > 0){
            this.preguntas = response['demograficos'];
          }else{
            this.preguntas = [];
            //this.getCatalogo();
          }
        }

      }, error => {
        console.log("error", error);
      });
  }

  public getBanderaDemograficos(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }

    this.demographicService.getBanderaDemograficos(data)
      .subscribe(response => {
        if(response['message'] == 'Success'){
          if(response.hasOwnProperty('bandera')){
            if(response['bandera'] == 0 || response['bandera'] == 1 || response['bandera'] == 2){
                this.banderaSelect = false;

            }else{
              this.banderaSelect = true;
            }
          }else{
            this.banderaSelect = true;
          }

        }
      }, error => {
        console.log("error", error);
      });
  }

  public setBanderaDemograficos(valor){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto'),
      bandera: valor
    }

    this.demographicService.setBanderaDemograficos(data)
      .subscribe(response => {

        console.log(response);
        if(response['message'] == 'Success'){
          if(response['bandera'] == 0 || response['bandera'] == 1 || response['bandera'] == 2){
              this.banderaSelect = false;
          }
        }
      }, error => {
        console.log("error", error);
      });
  }


  public addDemografico(clave){
    if(clave != undefined){
          let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            claveDemografico: clave
          }
          console.log(data);
          this.demographicService.saveNewDemografico(data)
            .subscribe(response => {
              console.log(response);
              if(response['message'] == 'Success'){
                  this.check(1);
                  this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.MJS_OPTIONADDED'),this.serviceTranslate.instant('ALERTS.OK'));
              }if(response['message'] == '605'){
                  this.openErrorSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.DEMOGRAPHICEXIST'),this.serviceTranslate.instant('ALERTS.OK'));
              }

              /*
              if(response['message'] == 'Success'){
                if(response['demograficos'].length > 0){
                    this.preguntas = response['demograficos'];
                }
              }*/

            }, error => {
              console.log("error", error);
            });

    }else{
      this.openErrorSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.MJS_SELECTOPTION'),this.serviceTranslate.instant('ALERTS.OK'));
    }
  }

  public deleteDemografico(clave){
          let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            idDemografico: clave
          }
          console.log(data);
          this.demographicService.deleteDemografico(data)
            .subscribe(response => {
              console.log(response);
              if(response['message2'] == 'Success'){
                  //this.check(1);
                  this.actualizarCheck=true;
                  this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.OPTIONDELETED'),this.serviceTranslate.instant('ALERTS.OK'));
              }else{
                  //this.openErrorSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.DEMOGRAPHICEXIST'),this.serviceTranslate.instant('ALERTS.OK'));
              }
          }, error => {
            console.log("error", error);
          });
  }

  public deleteRespuestaDemografico(id, idrespuesta ,posPregunta?, posOpc?){
          console.log(posPregunta, posOpc);
          
          let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            idDemografico: id,
            idOpcion: idrespuesta,
          }
          console.log(data);
          this.demographicService.deleteRespuestaDemografico(data)
            .subscribe(response => {
              console.log(response);
              if(response['success'] == true){
                  this.check(1);
                  for(let i =0; i < this.preguntas.length ; i++){
                    if(this.preguntas[i]._id == id){
                      for(let j =0; j < this.preguntas.length ; j++){
                        if(this.preguntas[i].opciones[j]._id == idrespuesta){
                          this.preguntas[i].opciones.splice(j,1);
                          break;
                        }
                      }
                    }
                  }
                  this.actualizarCheck=true;
                  this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.RESPONSEOPTIONDELETED'),this.serviceTranslate.instant('ALERTS.OK'));
              }else{
                  //this.openErrorSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.DEMOGRAPHICEXIST'),this.serviceTranslate.instant('ALERTS.OK'));
              }
          }, error => {
            console.log("error", error);
          });
  }

  agregaPregunta(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto'),
      orden: this.preguntas[this.preguntas.length-1].orden+1,

      tipo: 1,
      excel: 0,
      obligatorio: 0,
      clave: 'Clave'
    }


    this.demographicService.addquestion(data)
      .subscribe(response => {
        console.log(response);

        if(response['message'] == 'Success'){
          this.preguntas.push({
                  clave: this.serviceTranslate.instant('CERTIFICAR.DEMOGRAFICOS.CLAVE'),
                  excel: 0,
                  obligatorio: 0,
                  opciones:[],
                  orden: this.preguntas[this.preguntas.length-1].orden+1,
                  preguntaDemografico: "",
                  tipoRespuesta: 4,
                  traducciones: [],
                  vivoDemografico: "1",
                  tipoAgregado: 0,
                  _id: response['demografico']['_id']
          });
        }
      }, error => {
        console.log("error", error);
      });


  }

  public addResponse(dato){

    //let respuesta = this.preguntas.find(x=>x._id == dato).opciones;
    let respuesta = this.preguntas.find(x=>x._id == dato);
    if(respuesta['tipoRespuesta'] == 2){
      this.openErrorSnackBar(this.serviceTranslate.instant('CERTIFICAR.DEMOGRAFICOS.RESPONSE_NOT_ADDED'),this.serviceTranslate.instant('ALERTS.OK'));
    }else{
        let respuesta2 = this.preguntas.find(x=>x._id == dato);
        let size = this.preguntas.find(x=>x._id == dato).opciones.length;
        this.preguntas.find(x=>x._id == dato).opciones.push({ordenOpcion:size+1,textoOpcion:'',_id:'NEW'});
    }


  }

  public onBlurClave(event,pregunta){
    if(event.target.value.length > 0){
      let data = {
          fechaCertificar: localStorage.getItem('fechaProducto'),
          demograficoId: pregunta._id,
          clave: event.target.value
      };
      let respuesta = this.preguntas.find(x=>x._id == pregunta._id).clave = event.target.value;
      //this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.MSJ_TRANSLATEREGISTERED'),this.serviceTranslate.instant('ALERTS.OK'));
      this.updateData(data,this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDOK'));
    }else{
      this.openErrorSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDFAIL'),this.serviceTranslate.instant('ALERTS.OK'));
    }
  }

  selTipoPregunta(tipo,pregunta){
      let data = {
          fechaCertificar: localStorage.getItem('fechaProducto'),
          demograficoId: pregunta._id,
          tipo: tipo
      };
      let respuesta = this.preguntas.find(x=>x._id == pregunta._id).tipoRespuesta = tipo;
      //this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.MSJ_TRANSLATEREGISTERED'),this.serviceTranslate.instant('ALERTS.OK'));
      this.updateData(data,this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDOK'));

  }

  /* cambiaColorProgress() {
    const head = document.getElementsByTagName('head')[0];
    const css = `
    .body.temaFocusArea2 .accent-100 {
      background-color:  rgb(207, 221, 10) !important;
    }
    `;
    this.styleElement.innerHTML = '';
    this.styleElement.type = 'text/css';
    this.styleElement.appendChild(document.createTextNode(css));
    head.appendChild(this.styleElement);

  } */

/*
  private metodo(){
    let HPath="";

		switch ($("#changeCompany").val() ) {
		case "QV98NE28X":
			HPath = "TELEPERFORMANCE PHILIPPINES";
			break;
		case "QI27FW37P":
			HPath = "IPG MEDIABRANDS MÉXICO";
			break;
		case "DF9HX89Q":
			HPath = "FUNDACION TELETÓN";
			break;
		default:
			break;
		}
  }
*/
}
